import { render, staticRenderFns } from "./FormsetItem.vue?vue&type=template&id=46e1dd97&scoped=true&"
import script from "./FormsetItem.vue?vue&type=script&lang=js&"
export * from "./FormsetItem.vue?vue&type=script&lang=js&"
import style0 from "./FormsetItem.vue?vue&type=style&index=0&id=46e1dd97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1dd97",
  null
  
)

export default component.exports